import { produce } from 'immer'

export const removeItemFromTree = (id, tree) => {
  const { items } = tree

  // search all items to find children and then delete from that
  const itemParentId = Object.keys(items).find(itemId => items[itemId].children.includes(id))
  const itemChildrenIndex = items[itemParentId].children.findIndex(childKey => childKey === id)

  const treeWithoutItem = produce(tree, draftState => {
    // eslint-disable-next-line no-param-reassign
    delete draftState.items[id]
    draftState.items[itemParentId].children.splice(itemChildrenIndex, 1)
  })

  return treeWithoutItem
}

export const findItemSource = (tree, itemId) => {
  const { items } = tree
  const itemsKeys = Object.keys(items)
  const parentId = itemsKeys.find(key => items[key].children.includes(`${itemId}`))
  const parent = items[parentId]
  const index = parent.children.findIndex(child => child === itemId)
  return {
    parentId,
    index,
  }
}

// work around to limit nav depth to 2 children
export const computeSecondDepthDestination = ({
  items, rootId, destination, source
}) => {
  const { parentId } = destination

  // if source item has children it cannot be moved if the parent is not the root
  const sourceItemKey = items[source.parentId].children[source.index]
  const sourceItem = items[sourceItemKey]
  const sourceItemHasChildren = sourceItem.children.length > 0
  if (parentId !== rootId && sourceItemHasChildren) return source

  let parent = parentId
  const getParent = (items, parentId, rootId) => {
    // find out whos the parent
    const grandParentId = Object.keys(items).find(key => {
      const item = items[key]
      const grandParentId = item.children.includes(parentId)
      return grandParentId
    })
    // if the parent is not the rootId it means it isnt the second depth parent
    // repeat until second depth parent is found
    if (grandParentId !== rootId) getParent(items, grandParentId, rootId)
    // we found it!
    else parent = parentId
  }
  getParent(items, parentId, rootId)
  return {
    index: parent === destination.parentId ? (destination.index || 0) : 0,
    parentId: parent
  }
}

export const computeDestination = ({ tree, destination, source }) => {
  const { rootId, items } = tree
  // if the parentId is the rootId then its on the first depth
  // if the parentId is not the rootId its > 2nd depth
  const secondDepthDestination = destination.parentId === rootId
    ? destination
    : computeSecondDepthDestination({
      items, rootId, destination, source
    })

  return secondDepthDestination
}

export default function treeToNav(tree) {
  const { rootId, items } = tree
  const root = items[rootId]

  const schema = {
    ...root.data,
    tabs: [],
  }

  const rootChildren = root.children

  const convertTreeItemToNavItem = (id, isSecondDepth = false) => {
    const child = items[id]

    const props = child.data || {}
    const childChildren = child.children || []
    const links = childChildren.map(grandChild => {
      if (grandChild && grandChild !== id) return convertTreeItemToNavItem(grandChild, true)
      return []
    })

    const { title, text, ...rest } = props
    const data = isSecondDepth ? { text, ...rest } : { title, ...rest }

    return {
      ...data,
      links,
      hasLinks: links.length > 0,
    }
  }

  rootChildren.forEach(id => {
    schema.tabs = [...schema.tabs, convertTreeItemToNavItem(id)]
  })

  return schema
}
